/* Ta’seel — shop theme v2 behaviour.
   1. Drawers (menu, filters) and the Added-to-bag panel.
   2. Product list: filters, sort, category strip, colour bars on tiles.
   3. Product page: colour + size, photos, Add to bag (+ sticky bar on phones).
   4. Bag page: quantity changes. */
(function () {
  'use strict';

  var routes = (window.Taseel && window.Taseel.routes) || { cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change', root: '/' };
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function formatMoney(cents) {
    var format = (window.Taseel && window.Taseel.moneyFormat) || '£{{amount}}';
    var value = (cents / 100).toFixed(2);
    return format
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, value.replace(/\.00$/, ''))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/, value)
      .replace(/<[^>]*>/g, '');
  }
  function setCartCount(count) {
    $all('[data-cart-count]').forEach(function (el) { el.textContent = count; el.setAttribute('data-count', count); });
    $all('[data-bag-link]').forEach(function (a) { a.setAttribute('aria-label', 'Bag, ' + count + ' items'); });
  }

  /* ---------- 1. Drawers ---------- */
  var lastFocus = null;
  function openLayer(el) {
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    var focusTarget = $('[role="dialog"]', el) || el;
    if (focusTarget.focus) focusTarget.focus();
  }
  function closeLayer(el) {
    if (!el || !el.classList.contains('is-open')) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('is-locked');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* ---------- 2. Product list ---------- */
  var FACETS = ['category', 'design', 'colour', 'size', 'price'];

  function cardMatches(card, state, skip) {
    return FACETS.every(function (key) {
      if (key === skip) return true;
      var wanted = state[key];
      if (!wanted.length) return true;
      if (key === 'price') {
        var p = Number(card.getAttribute('data-price'));
        return wanted.some(function (range) { var b = range.split('-'); return p >= Number(b[0]) && p < Number(b[1]); });
      }
      var attr = key === 'colour' ? 'data-colours' : key === 'size' ? 'data-sizes' : 'data-' + key;
      var have = (card.getAttribute(attr) || '').split(',');
      return wanted.some(function (w) { return have.indexOf(w) > -1; });
    });
  }

  function initPlp(plp) {
    var grid = $('[data-plp-grid]', plp);
    if (!grid) return;
    var cards = $all('[data-card]', grid);
    var facets = $('[data-facets]', plp);
    var state = { category: [], design: [], colour: [], size: [], price: [], sort: 'featured' };

    var params = new URLSearchParams(window.location.search);
    FACETS.forEach(function (k) { state[k] = params.getAll(k); });
    if (params.get('sort')) state.sort = params.get('sort');

    function syncInputs() {
      $all('[data-facet]', plp).forEach(function (input) {
        input.checked = state[input.getAttribute('data-facet')].indexOf(input.value) > -1;
      });
      $all('[data-quick]', plp).forEach(function (b) {
        b.setAttribute('aria-pressed', String(state[b.getAttribute('data-quick')].indexOf(b.getAttribute('data-value')) > -1));
      });
      $all('[data-sort]', plp).forEach(function (s) { s.value = state.sort; });
    }

    function apply() {
      var shown = 0;
      cards.forEach(function (card) {
        var ok = cardMatches(card, state);
        card.hidden = !ok;
        if (ok) shown++;
      });
      // sort
      var sorted = cards.slice().sort(function (a, b) {
        if (state.sort === 'price-asc') return a.getAttribute('data-price') - b.getAttribute('data-price');
        if (state.sort === 'price-desc') return b.getAttribute('data-price') - a.getAttribute('data-price');
        if (state.sort === 'title') return a.getAttribute('data-title').localeCompare(b.getAttribute('data-title'));
        return a.getAttribute('data-index') - b.getAttribute('data-index');
      });
      sorted.forEach(function (c) { grid.appendChild(c); });

      $all('[data-plp-count]', plp).forEach(function (el) { el.textContent = shown; });
      var empty = $('[data-plp-empty]', plp);
      if (empty) empty.hidden = shown !== 0;

      // counts per option (as if that option were added)
      $all('[data-count-for]', plp).forEach(function (el) {
        var parts = el.getAttribute('data-count-for').split(':');
        var key = parts[0], val = parts.slice(1).join(':');
        var trial = {}; FACETS.forEach(function (k) { trial[k] = k === key ? [val] : state[k]; });
        var n = cards.filter(function (c) { return cardMatches(c, trial); }).length;
        el.textContent = '(' + n + ')';
        var opt = el.closest('.facet__option');
        if (opt) opt.classList.toggle('is-empty', n === 0);
      });

      // applied chips
      var applied = $('[data-applied]', plp);
      var total = 0;
      if (applied) {
        applied.innerHTML = '';
        FACETS.forEach(function (k) {
          state[k].forEach(function (v) {
            total++;
            var b = document.createElement('button');
            b.type = 'button'; b.className = 'applied__chip';
            var label = k === 'price' ? priceLabel(v) : v;
            b.textContent = label;
            b.setAttribute('aria-label', 'Remove filter ' + label);
            b.addEventListener('click', function () { state[k] = state[k].filter(function (x) { return x !== v; }); syncInputs(); apply(); });
            applied.appendChild(b);
          });
        });
        if (total > 1) {
          var clear = document.createElement('button');
          clear.type = 'button'; clear.className = 'link-button'; clear.textContent = 'Clear all';
          clear.addEventListener('click', clearAll);
          applied.appendChild(clear);
        }
      }
      $all('[data-filter-count]', plp).forEach(function (el) { el.textContent = total ? '(' + total + ')' : ''; });

      var url = new URL(window.location.href);
      FACETS.concat(['sort']).forEach(function (k) { url.searchParams.delete(k); });
      FACETS.forEach(function (k) { state[k].forEach(function (v) { url.searchParams.append(k, v); }); });
      if (state.sort !== 'featured') url.searchParams.set('sort', state.sort);
      window.history.replaceState({}, '', url.toString());
    }

    function priceLabel(v) {
      var b = v.split('-');
      if (Number(b[0]) === 0) return 'Under ' + formatMoney(Number(b[1])).replace('.00', '');
      if (Number(b[1]) > 99999) return 'Over ' + formatMoney(Number(b[0])).replace('.00', '');
      return formatMoney(Number(b[0])).replace('.00', '') + '–' + formatMoney(Number(b[1])).replace('.00', '');
    }
    function clearAll() { FACETS.forEach(function (k) { state[k] = []; }); syncInputs(); apply(); }

    $all('[data-facet]', plp).forEach(function (input) {
      input.addEventListener('change', function () {
        var key = input.getAttribute('data-facet');
        state[key] = state[key].filter(function (x) { return x !== input.value; });
        if (input.checked) state[key].push(input.value);
        apply();
      });
    });
    $all('[data-quick]', plp).forEach(function (b) {
      b.addEventListener('click', function () {
        var key = b.getAttribute('data-quick'), val = b.getAttribute('data-value');
        state[key] = state[key].indexOf(val) > -1 ? [] : [val];
        syncInputs(); apply();
      });
    });
    $all('[data-sort]', plp).forEach(function (s) {
      s.addEventListener('change', function () { state.sort = s.value; syncInputs(); apply(); });
    });
    $all('[data-filter-clear]', plp).forEach(function (b) { b.addEventListener('click', clearAll); });
    $all('[data-filter-open]', plp).forEach(function (b) {
      b.addEventListener('click', function () {
        lastFocus = b;
        facets.classList.add('is-open');
        document.body.classList.add('is-locked');
        var first = $('summary', facets); if (first) first.focus();
      });
    });
    $all('[data-filter-close]', plp).forEach(function (b) {
      b.addEventListener('click', function () {
        facets.classList.remove('is-open');
        document.body.classList.remove('is-locked');
        if (lastFocus) lastFocus.focus();
      });
    });

    syncInputs();
    apply();
  }

  function initCardSwatches(root) {
    $all('[data-swatch]', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var card = btn.closest('[data-card]');
        if (!card) return;
        $all('[data-swatch]', card).forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
        btn.setAttribute('aria-pressed', 'true');
        var img = $('.card__media img', card);
        var src = btn.getAttribute('data-image');
        if (img && src) {
          img.removeAttribute('srcset');
          img.src = src;
          img.alt = card.getAttribute('data-title') + ', ' + btn.getAttribute('aria-label');
        }
        var url = btn.getAttribute('data-url');
        if (url) $all('[data-card-link]', card).forEach(function (a) { a.href = url; });
      });
    });
  }

  /* ---------- 3. Product page ---------- */
  function initPdp(pdp) {
    var jsonEl = $('[data-product-json]');
    var form = $('[data-product-form]', pdp);
    if (!jsonEl || !form) return;
    var data = JSON.parse(jsonEl.textContent);
    var ci = data.colourIndex, si = data.sizeIndex;
    var idInput = $('[data-variant-id]', form);
    var addBtn = $('[data-add]', form);
    var message = $('[data-form-message]', form);
    var sizeError = $('[data-size-error]', form);
    var sizeGrid = $('[data-size-grid]', form);
    var priceEl = $('[data-price]', pdp);
    var track = $('[data-gallery]', pdp);
    var dots = $('[data-dots]', pdp);
    var select = $('[data-variant-select]', form);
    var sticky = $('[data-sticky-add]');

    function current(name) { var el = $('input[data-option="' + name + '"]:checked', form); return el ? el.value : null; }
    function find(colour, size) {
      return data.variants.filter(function (v) { return (ci < 0 || v.options[ci] === colour) && (si < 0 || v.options[si] === size); })[0];
    }
    function firstForColour(colour) {
      var list = data.variants.filter(function (v) { return ci < 0 || v.options[ci] === colour; });
      return list.filter(function (v) { return v.available; })[0] || list[0];
    }

    function showPhotos(colour) {
      if (!track) return;
      var slides = $all('[data-slide]', track);
      var any = slides.some(function (s) { return s.getAttribute('data-colour') === colour; });
      var visible = 0;
      slides.forEach(function (s) {
        var c = s.getAttribute('data-colour');
        var show = !any || !c || c === colour;
        s.hidden = !show;
        if (show) visible++;
      });
      track.classList.toggle('is-single', visible <= 1);
      track.scrollLeft = 0;
      if (dots) {
        dots.innerHTML = '';
        if (visible > 1) for (var i = 0; i < visible; i++) { var d = document.createElement('span'); if (!i) d.className = 'is-active'; dots.appendChild(d); }
      }
    }

    function update() {
      var colour = ci >= 0 ? current('colour') : null;
      var size = si >= 0 ? current('size') : null;

      if (si >= 0) {
        $all('input[data-option="size"]', form).forEach(function (input) {
          var v = find(colour, input.value);
          var soldOut = !v || !v.available;
          input.closest('[data-size-label]').classList.toggle('is-soldout', soldOut);
          input.disabled = soldOut;
          input.setAttribute('aria-label', input.value + (soldOut ? ' (sold out)' : ''));
          if (soldOut && input.checked) { input.checked = false; size = null; }
        });
      }

      var variant = (si >= 0 && !size) ? firstForColour(colour) : find(colour, size);
      if (variant) {
        idInput.value = variant.id;
        if (priceEl) priceEl.innerHTML = (variant.compare ? '<s>' + variant.compare + '</s>' : '') + variant.price;
        var sku = $('[data-sku]', pdp); if (sku && variant.sku) sku.textContent = variant.sku;
      }
      var cv = $('[data-colour-value]', pdp); if (cv && colour) cv.textContent = colour;
      var sv = $('[data-size-value]', pdp); if (sv) sv.textContent = size || '';

      var soldOut = variant && !variant.available && (si < 0 || size);
      addBtn.disabled = !!soldOut;
      addBtn.textContent = soldOut ? 'Sold out' : 'Add to bag';

      if (variant && (si < 0 || size)) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    $all('input[data-option]', form).forEach(function (input) {
      input.addEventListener('change', function () {
        if (message) message.textContent = '';
        if (input.getAttribute('data-option') === 'size') {
          if (sizeError) sizeError.textContent = '';
          if (sizeGrid) sizeGrid.classList.remove('is-error');
        }
        if (input.getAttribute('data-option') === 'colour') showPhotos(input.value);
        update();
      });
    });
    if (select) select.addEventListener('change', function () { idInput.value = select.value; });

    if (track && dots) {
      track.addEventListener('scroll', function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        $all('span', dots).forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
      }, { passive: true });
    }

    function submit() {
      if (si >= 0 && !current('size')) {
        if (sizeError) sizeError.textContent = 'Please choose a size.';
        if (sizeGrid) {
          sizeGrid.classList.add('is-error');
          sizeGrid.scrollIntoView({ behavior: 'smooth', block: 'center' });
          var first = $('input[data-option="size"]:not(:disabled)', form); if (first) first.focus({ preventScroll: true });
        }
        return;
      }
      var qty = parseInt(($('[data-qty-select]', form) || {}).value, 10) || 1;
      addBtn.disabled = true;
      addBtn.textContent = 'Adding…';
      fetch(routes.cartAdd + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(idInput.value), quantity: qty }] })
      })
        .then(function (r) { return r.json().then(function (body) { return { ok: r.ok, body: body }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.body.description || res.body.message || 'Could not add to bag.');
          var item = res.body.items ? res.body.items[0] : res.body;
          return fetch(routes.cart + '.js', { headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (cart) { openBagPopup(item, qty, cart); });
        })
        .catch(function (err) { if (message) message.textContent = err.message; })
        .then(function () { update(); });
    }
    form.addEventListener('submit', function (e) { e.preventDefault(); submit(); });

    // Sticky Add to bag on phones while the main button is off screen
    if (sticky && 'IntersectionObserver' in window) {
      var stickyBtn = $('[data-sticky-add-button]', sticky);
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top > 0);
      }).observe(addBtn);
      stickyBtn.addEventListener('click', submit);
    }

    if (ci >= 0) showPhotos(current('colour'));
    update();
  }

  /* ---------- Added-to-bag panel ---------- */
  function openBagPopup(item, qty, cart) {
    var pop = document.getElementById('BagPopup');
    if (!pop) { window.location.href = routes.cart; return; }
    var img = $('[data-bag-image]', pop);
    if (item.image) { img.src = item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=200'; img.alt = item.product_title; img.hidden = false; } else { img.hidden = true; }
    $('[data-bag-title]', pop).textContent = item.product_title;
    $('[data-bag-variant]', pop).textContent = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
    $('[data-bag-qty]', pop).textContent = 'Qty: ' + qty;
    $('[data-bag-price]', pop).textContent = formatMoney(item.final_price * qty);
    $('[data-bag-count]', pop).textContent = cart.item_count + (cart.item_count === 1 ? ' item' : ' items');
    $('[data-bag-subtotal]', pop).textContent = formatMoney(cart.total_price);
    setCartCount(cart.item_count);
    openLayer(pop);
  }

  /* ---------- 4. Bag page ---------- */
  function initCart(cartEl) {
    $all('[data-line-qty]', cartEl).forEach(function (sel) {
      sel.addEventListener('change', function () { changeLine(sel.getAttribute('data-line-qty'), Number(sel.value)); });
    });
    $all('[data-line-remove]', cartEl).forEach(function (b) {
      b.addEventListener('click', function () { changeLine(b.getAttribute('data-line-remove'), 0); });
    });
    function changeLine(line, quantity) {
      cartEl.setAttribute('aria-busy', 'true');
      fetch(routes.cartChange + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: Number(line), quantity: quantity })
      }).then(function () { window.location.reload(); });
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    $all('[data-plp]').forEach(initPlp);
    initCardSwatches(document);
    $all('[data-pdp]').forEach(initPdp);
    $all('[data-cart]').forEach(initCart);

    $all('[data-drawer-open]').forEach(function (b) {
      b.addEventListener('click', function () { var d = document.getElementById(b.getAttribute('data-drawer-open')); if (d) openLayer(d); });
    });
    $all('[data-drawer-close], [data-bag-close]').forEach(function (b) {
      b.addEventListener('click', function () { closeLayer(b.closest('.drawer, .bag-popup')); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      $all('.drawer.is-open, .bag-popup.is-open').forEach(closeLayer);
      $all('[data-facets].is-open').forEach(function (f) { f.classList.remove('is-open'); document.body.classList.remove('is-locked'); });
    });
  });
})();
